export const UPDATE_EMAIL = 'UPDATE_EMAIL'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_FAIL = 'SET_USER_FAIL'
